import { GrowthDataSet } from '../../types/data-set.types';

export const whoGirlsHeadCircumferenceMonthly: GrowthDataSet = {
  id: 'who-girls-head-circumference-monthly-0-5',
  source: 'WHO',
  title: 'Head circumference-for-age',
  intervalType: 'month',
  gender: 'female',
  measurementType: 'head_circumference',
  ageRange: { min: 0, max: 60 },
  displayUnit: 'cm',
  dataPoints: [
    {
      age: 0,
      m: 33.8787,
      s: 0.03496,
      sd: 1.1844,
      percentiles: {
        p1: 31.1,
        p3: 31.7,
        p5: 31.9,
        p15: 32.7,
        p25: 33.1,
        p50: 33.9,
        p75: 34.7,
        p85: 35.1,
        p95: 35.8,
        p97: 36.1,
        p99: 36.6,
      },
    },
    {
      age: 1,
      m: 36.5463,
      s: 0.0321,
      sd: 1.1731,
      percentiles: {
        p1: 33.8,
        p3: 34.3,
        p5: 34.6,
        p15: 35.3,
        p25: 35.8,
        p50: 36.5,
        p75: 37.3,
        p85: 37.8,
        p95: 38.5,
        p97: 38.8,
        p99: 39.3,
      },
    },
    {
      age: 2,
      m: 38.2521,
      s: 0.03168,
      sd: 1.2118,
      percentiles: {
        p1: 35.4,
        p3: 36.0,
        p5: 36.3,
        p15: 37.0,
        p25: 37.4,
        p50: 38.3,
        p75: 39.1,
        p85: 39.5,
        p95: 40.2,
        p97: 40.5,
        p99: 41.1,
      },
    },
    {
      age: 3,
      m: 39.5328,
      s: 0.0314,
      sd: 1.2413,
      percentiles: {
        p1: 36.6,
        p3: 37.2,
        p5: 37.5,
        p15: 38.2,
        p25: 38.7,
        p50: 39.5,
        p75: 40.4,
        p85: 40.8,
        p95: 41.6,
        p97: 41.9,
        p99: 42.4,
      },
    },
    {
      age: 4,
      m: 40.5817,
      s: 0.03119,
      sd: 1.2657,
      percentiles: {
        p1: 37.6,
        p3: 38.2,
        p5: 38.5,
        p15: 39.3,
        p25: 39.7,
        p50: 40.6,
        p75: 41.4,
        p85: 41.9,
        p95: 42.7,
        p97: 43.0,
        p99: 43.5,
      },
    },
    {
      age: 5,
      m: 41.459,
      s: 0.03102,
      sd: 1.2861,
      percentiles: {
        p1: 38.5,
        p3: 39.0,
        p5: 39.3,
        p15: 40.1,
        p25: 40.6,
        p50: 41.5,
        p75: 42.3,
        p85: 42.8,
        p95: 43.6,
        p97: 43.9,
        p99: 44.5,
      },
    },
    {
      age: 6,
      m: 42.1995,
      s: 0.03087,
      sd: 1.3027,
      percentiles: {
        p1: 39.2,
        p3: 39.7,
        p5: 40.1,
        p15: 40.8,
        p25: 41.3,
        p50: 42.2,
        p75: 43.1,
        p85: 43.5,
        p95: 44.3,
        p97: 44.6,
        p99: 45.2,
      },
    },
    {
      age: 7,
      m: 42.829,
      s: 0.03075,
      sd: 1.317,
      percentiles: {
        p1: 39.8,
        p3: 40.4,
        p5: 40.7,
        p15: 41.5,
        p25: 41.9,
        p50: 42.8,
        p75: 43.7,
        p85: 44.2,
        p95: 45.0,
        p97: 45.3,
        p99: 45.9,
      },
    },
    {
      age: 8,
      m: 43.3671,
      s: 0.03063,
      sd: 1.3283,
      percentiles: {
        p1: 40.3,
        p3: 40.9,
        p5: 41.2,
        p15: 42.0,
        p25: 42.5,
        p50: 43.4,
        p75: 44.3,
        p85: 44.7,
        p95: 45.6,
        p97: 45.9,
        p99: 46.5,
      },
    },
    {
      age: 9,
      m: 43.83,
      s: 0.03053,
      sd: 1.3381,
      percentiles: {
        p1: 40.7,
        p3: 41.3,
        p5: 41.6,
        p15: 42.4,
        p25: 42.9,
        p50: 43.8,
        p75: 44.7,
        p85: 45.2,
        p95: 46.0,
        p97: 46.3,
        p99: 46.9,
      },
    },
    {
      age: 10,
      m: 44.2319,
      s: 0.03044,
      sd: 1.3464,
      percentiles: {
        p1: 41.1,
        p3: 41.7,
        p5: 42.0,
        p15: 42.8,
        p25: 43.3,
        p50: 44.2,
        p75: 45.1,
        p85: 45.6,
        p95: 46.4,
        p97: 46.8,
        p99: 47.4,
      },
    },
    {
      age: 11,
      m: 44.5844,
      s: 0.03035,
      sd: 1.3531,
      percentiles: {
        p1: 41.4,
        p3: 42.0,
        p5: 42.4,
        p15: 43.2,
        p25: 43.7,
        p50: 44.6,
        p75: 45.5,
        p85: 46.0,
        p95: 46.8,
        p97: 47.1,
        p99: 47.7,
      },
    },
    {
      age: 12,
      m: 44.8965,
      s: 0.03027,
      sd: 1.359,
      percentiles: {
        p1: 41.7,
        p3: 42.3,
        p5: 42.7,
        p15: 43.5,
        p25: 44.0,
        p50: 44.9,
        p75: 45.8,
        p85: 46.3,
        p95: 47.1,
        p97: 47.5,
        p99: 48.1,
      },
    },
    {
      age: 13,
      m: 45.1752,
      s: 0.03019,
      sd: 1.3638,
      percentiles: {
        p1: 42.0,
        p3: 42.6,
        p5: 42.9,
        p15: 43.8,
        p25: 44.3,
        p50: 45.2,
        p75: 46.1,
        p85: 46.6,
        p95: 47.4,
        p97: 47.7,
        p99: 48.3,
      },
    },
    {
      age: 14,
      m: 45.4265,
      s: 0.03012,
      sd: 1.3683,
      percentiles: {
        p1: 42.2,
        p3: 42.9,
        p5: 43.2,
        p15: 44.0,
        p25: 44.5,
        p50: 45.4,
        p75: 46.3,
        p85: 46.8,
        p95: 47.7,
        p97: 48.0,
        p99: 48.6,
      },
    },
    {
      age: 15,
      m: 45.6551,
      s: 0.03006,
      sd: 1.3724,
      percentiles: {
        p1: 42.5,
        p3: 43.1,
        p5: 43.4,
        p15: 44.2,
        p25: 44.7,
        p50: 45.7,
        p75: 46.6,
        p85: 47.1,
        p95: 47.9,
        p97: 48.2,
        p99: 48.8,
      },
    },
    {
      age: 16,
      m: 45.865,
      s: 0.02999,
      sd: 1.3755,
      percentiles: {
        p1: 42.7,
        p3: 43.3,
        p5: 43.6,
        p15: 44.4,
        p25: 44.9,
        p50: 45.9,
        p75: 46.8,
        p85: 47.3,
        p95: 48.1,
        p97: 48.5,
        p99: 49.1,
      },
    },
    {
      age: 17,
      m: 46.0598,
      s: 0.02993,
      sd: 1.3786,
      percentiles: {
        p1: 42.9,
        p3: 43.5,
        p5: 43.8,
        p15: 44.6,
        p25: 45.1,
        p50: 46.1,
        p75: 47.0,
        p85: 47.5,
        p95: 48.3,
        p97: 48.7,
        p99: 49.3,
      },
    },
    {
      age: 18,
      m: 46.2424,
      s: 0.02987,
      sd: 1.3813,
      percentiles: {
        p1: 43.0,
        p3: 43.6,
        p5: 44.0,
        p15: 44.8,
        p25: 45.3,
        p50: 46.2,
        p75: 47.2,
        p85: 47.7,
        p95: 48.5,
        p97: 48.8,
        p99: 49.5,
      },
    },
    {
      age: 19,
      m: 46.4152,
      s: 0.02982,
      sd: 1.3841,
      percentiles: {
        p1: 43.2,
        p3: 43.8,
        p5: 44.1,
        p15: 45.0,
        p25: 45.5,
        p50: 46.4,
        p75: 47.3,
        p85: 47.8,
        p95: 48.7,
        p97: 49.0,
        p99: 49.6,
      },
    },
    {
      age: 20,
      m: 46.5801,
      s: 0.02977,
      sd: 1.3867,
      percentiles: {
        p1: 43.4,
        p3: 44.0,
        p5: 44.3,
        p15: 45.1,
        p25: 45.6,
        p50: 46.6,
        p75: 47.5,
        p85: 48.0,
        p95: 48.9,
        p97: 49.2,
        p99: 49.8,
      },
    },
    {
      age: 21,
      m: 46.7384,
      s: 0.02972,
      sd: 1.3891,
      percentiles: {
        p1: 43.5,
        p3: 44.1,
        p5: 44.5,
        p15: 45.3,
        p25: 45.8,
        p50: 46.7,
        p75: 47.7,
        p85: 48.2,
        p95: 49.0,
        p97: 49.4,
        p99: 50.0,
      },
    },
    {
      age: 22,
      m: 46.8913,
      s: 0.02967,
      sd: 1.3913,
      percentiles: {
        p1: 43.7,
        p3: 44.3,
        p5: 44.6,
        p15: 45.4,
        p25: 46.0,
        p50: 46.9,
        p75: 47.8,
        p85: 48.3,
        p95: 49.2,
        p97: 49.5,
        p99: 50.1,
      },
    },
    {
      age: 23,
      m: 47.0391,
      s: 0.02962,
      sd: 1.3933,
      percentiles: {
        p1: 43.8,
        p3: 44.4,
        p5: 44.7,
        p15: 45.6,
        p25: 46.1,
        p50: 47.0,
        p75: 48.0,
        p85: 48.5,
        p95: 49.3,
        p97: 49.7,
        p99: 50.3,
      },
    },
    {
      age: 24,
      m: 47.1822,
      s: 0.02957,
      sd: 1.3952,
      percentiles: {
        p1: 43.9,
        p3: 44.6,
        p5: 44.9,
        p15: 45.7,
        p25: 46.2,
        p50: 47.2,
        p75: 48.1,
        p85: 48.6,
        p95: 49.5,
        p97: 49.8,
        p99: 50.4,
      },
    },
    {
      age: 25,
      m: 47.3204,
      s: 0.02953,
      sd: 1.3974,
      percentiles: {
        p1: 44.1,
        p3: 44.7,
        p5: 45.0,
        p15: 45.9,
        p25: 46.4,
        p50: 47.3,
        p75: 48.3,
        p85: 48.8,
        p95: 49.6,
        p97: 49.9,
        p99: 50.6,
      },
    },
    {
      age: 26,
      m: 47.4536,
      s: 0.02949,
      sd: 1.3994,
      percentiles: {
        p1: 44.2,
        p3: 44.8,
        p5: 45.2,
        p15: 46.0,
        p25: 46.5,
        p50: 47.5,
        p75: 48.4,
        p85: 48.9,
        p95: 49.8,
        p97: 50.1,
        p99: 50.7,
      },
    },
    {
      age: 27,
      m: 47.5817,
      s: 0.02945,
      sd: 1.4013,
      percentiles: {
        p1: 44.3,
        p3: 44.9,
        p5: 45.3,
        p15: 46.1,
        p25: 46.6,
        p50: 47.6,
        p75: 48.5,
        p85: 49.0,
        p95: 49.9,
        p97: 50.2,
        p99: 50.8,
      },
    },
    {
      age: 28,
      m: 47.7045,
      s: 0.02941,
      sd: 1.403,
      percentiles: {
        p1: 44.4,
        p3: 45.1,
        p5: 45.4,
        p15: 46.3,
        p25: 46.8,
        p50: 47.7,
        p75: 48.7,
        p85: 49.2,
        p95: 50.0,
        p97: 50.3,
        p99: 51.0,
      },
    },
    {
      age: 29,
      m: 47.8219,
      s: 0.02937,
      sd: 1.4045,
      percentiles: {
        p1: 44.6,
        p3: 45.2,
        p5: 45.5,
        p15: 46.4,
        p25: 46.9,
        p50: 47.8,
        p75: 48.8,
        p85: 49.3,
        p95: 50.1,
        p97: 50.5,
        p99: 51.1,
      },
    },
    {
      age: 30,
      m: 47.934,
      s: 0.02933,
      sd: 1.4059,
      percentiles: {
        p1: 44.7,
        p3: 45.3,
        p5: 45.6,
        p15: 46.5,
        p25: 47.0,
        p50: 47.9,
        p75: 48.9,
        p85: 49.4,
        p95: 50.2,
        p97: 50.6,
        p99: 51.2,
      },
    },
    {
      age: 31,
      m: 48.041,
      s: 0.02929,
      sd: 1.4071,
      percentiles: {
        p1: 44.8,
        p3: 45.4,
        p5: 45.7,
        p15: 46.6,
        p25: 47.1,
        p50: 48.0,
        p75: 49.0,
        p85: 49.5,
        p95: 50.4,
        p97: 50.7,
        p99: 51.3,
      },
    },
    {
      age: 32,
      m: 48.1432,
      s: 0.02926,
      sd: 1.4087,
      percentiles: {
        p1: 44.9,
        p3: 45.5,
        p5: 45.8,
        p15: 46.7,
        p25: 47.2,
        p50: 48.1,
        p75: 49.1,
        p85: 49.6,
        p95: 50.5,
        p97: 50.8,
        p99: 51.4,
      },
    },
    {
      age: 33,
      m: 48.2408,
      s: 0.02922,
      sd: 1.4096,
      percentiles: {
        p1: 45.0,
        p3: 45.6,
        p5: 45.9,
        p15: 46.8,
        p25: 47.3,
        p50: 48.2,
        p75: 49.2,
        p85: 49.7,
        p95: 50.6,
        p97: 50.9,
        p99: 51.5,
      },
    },
    {
      age: 34,
      m: 48.3343,
      s: 0.02919,
      sd: 1.4109,
      percentiles: {
        p1: 45.1,
        p3: 45.7,
        p5: 46.0,
        p15: 46.9,
        p25: 47.4,
        p50: 48.3,
        p75: 49.3,
        p85: 49.8,
        p95: 50.7,
        p97: 51.0,
        p99: 51.6,
      },
    },
    {
      age: 35,
      m: 48.4239,
      s: 0.02915,
      sd: 1.4116,
      percentiles: {
        p1: 45.1,
        p3: 45.8,
        p5: 46.1,
        p15: 47.0,
        p25: 47.5,
        p50: 48.4,
        p75: 49.4,
        p85: 49.9,
        p95: 50.7,
        p97: 51.1,
        p99: 51.7,
      },
    },
    {
      age: 36,
      m: 48.5099,
      s: 0.02912,
      sd: 1.4126,
      percentiles: {
        p1: 45.2,
        p3: 45.9,
        p5: 46.2,
        p15: 47.0,
        p25: 47.6,
        p50: 48.5,
        p75: 49.5,
        p85: 50.0,
        p95: 50.8,
        p97: 51.2,
        p99: 51.8,
      },
    },
    {
      age: 37,
      m: 48.5926,
      s: 0.02909,
      sd: 1.4136,
      percentiles: {
        p1: 45.3,
        p3: 45.9,
        p5: 46.3,
        p15: 47.1,
        p25: 47.6,
        p50: 48.6,
        p75: 49.5,
        p85: 50.1,
        p95: 50.9,
        p97: 51.3,
        p99: 51.9,
      },
    },
    {
      age: 38,
      m: 48.6722,
      s: 0.02906,
      sd: 1.4144,
      percentiles: {
        p1: 45.4,
        p3: 46.0,
        p5: 46.3,
        p15: 47.2,
        p25: 47.7,
        p50: 48.7,
        p75: 49.6,
        p85: 50.1,
        p95: 51.0,
        p97: 51.3,
        p99: 52.0,
      },
    },
    {
      age: 39,
      m: 48.7489,
      s: 0.02903,
      sd: 1.4152,
      percentiles: {
        p1: 45.5,
        p3: 46.1,
        p5: 46.4,
        p15: 47.3,
        p25: 47.8,
        p50: 48.7,
        p75: 49.7,
        p85: 50.2,
        p95: 51.1,
        p97: 51.4,
        p99: 52.0,
      },
    },
    {
      age: 40,
      m: 48.8228,
      s: 0.029,
      sd: 1.4159,
      percentiles: {
        p1: 45.5,
        p3: 46.2,
        p5: 46.5,
        p15: 47.4,
        p25: 47.9,
        p50: 48.8,
        p75: 49.8,
        p85: 50.3,
        p95: 51.2,
        p97: 51.5,
        p99: 52.1,
      },
    },
    {
      age: 41,
      m: 48.8941,
      s: 0.02897,
      sd: 1.4165,
      percentiles: {
        p1: 45.6,
        p3: 46.2,
        p5: 46.6,
        p15: 47.4,
        p25: 47.9,
        p50: 48.9,
        p75: 49.8,
        p85: 50.4,
        p95: 51.2,
        p97: 51.6,
        p99: 52.2,
      },
    },
    {
      age: 42,
      m: 48.9629,
      s: 0.02894,
      sd: 1.417,
      percentiles: {
        p1: 45.7,
        p3: 46.3,
        p5: 46.6,
        p15: 47.5,
        p25: 48.0,
        p50: 49.0,
        p75: 49.9,
        p85: 50.4,
        p95: 51.3,
        p97: 51.6,
        p99: 52.3,
      },
    },
    {
      age: 43,
      m: 49.0294,
      s: 0.02891,
      sd: 1.4174,
      percentiles: {
        p1: 45.7,
        p3: 46.4,
        p5: 46.7,
        p15: 47.6,
        p25: 48.1,
        p50: 49.0,
        p75: 50.0,
        p85: 50.5,
        p95: 51.4,
        p97: 51.7,
        p99: 52.3,
      },
    },
    {
      age: 44,
      m: 49.0937,
      s: 0.02888,
      sd: 1.4178,
      percentiles: {
        p1: 45.8,
        p3: 46.4,
        p5: 46.8,
        p15: 47.6,
        p25: 48.1,
        p50: 49.1,
        p75: 50.1,
        p85: 50.6,
        p95: 51.4,
        p97: 51.8,
        p99: 52.4,
      },
    },
    {
      age: 45,
      m: 49.156,
      s: 0.02886,
      sd: 1.4186,
      percentiles: {
        p1: 45.9,
        p3: 46.5,
        p5: 46.8,
        p15: 47.7,
        p25: 48.2,
        p50: 49.2,
        p75: 50.1,
        p85: 50.6,
        p95: 51.5,
        p97: 51.8,
        p99: 52.5,
      },
    },
    {
      age: 46,
      m: 49.2164,
      s: 0.02883,
      sd: 1.4189,
      percentiles: {
        p1: 45.9,
        p3: 46.5,
        p5: 46.9,
        p15: 47.7,
        p25: 48.3,
        p50: 49.2,
        p75: 50.2,
        p85: 50.7,
        p95: 51.6,
        p97: 51.9,
        p99: 52.5,
      },
    },
    {
      age: 47,
      m: 49.2751,
      s: 0.0288,
      sd: 1.4191,
      percentiles: {
        p1: 46.0,
        p3: 46.6,
        p5: 46.9,
        p15: 47.8,
        p25: 48.3,
        p50: 49.3,
        p75: 50.2,
        p85: 50.7,
        p95: 51.6,
        p97: 51.9,
        p99: 52.6,
      },
    },
    {
      age: 48,
      m: 49.3321,
      s: 0.02878,
      sd: 1.4198,
      percentiles: {
        p1: 46.0,
        p3: 46.7,
        p5: 47.0,
        p15: 47.9,
        p25: 48.4,
        p50: 49.3,
        p75: 50.3,
        p85: 50.8,
        p95: 51.7,
        p97: 52.0,
        p99: 52.6,
      },
    },
    {
      age: 49,
      m: 49.3877,
      s: 0.02875,
      sd: 1.4199,
      percentiles: {
        p1: 46.1,
        p3: 46.7,
        p5: 47.1,
        p15: 47.9,
        p25: 48.4,
        p50: 49.4,
        p75: 50.3,
        p85: 50.9,
        p95: 51.7,
        p97: 52.1,
        p99: 52.7,
      },
    },
    {
      age: 50,
      m: 49.4419,
      s: 0.02873,
      sd: 1.4205,
      percentiles: {
        p1: 46.1,
        p3: 46.8,
        p5: 47.1,
        p15: 48.0,
        p25: 48.5,
        p50: 49.4,
        p75: 50.4,
        p85: 50.9,
        p95: 51.8,
        p97: 52.1,
        p99: 52.7,
      },
    },
    {
      age: 51,
      m: 49.4947,
      s: 0.0287,
      sd: 1.4205,
      percentiles: {
        p1: 46.2,
        p3: 46.8,
        p5: 47.2,
        p15: 48.0,
        p25: 48.5,
        p50: 49.5,
        p75: 50.5,
        p85: 51.0,
        p95: 51.8,
        p97: 52.2,
        p99: 52.8,
      },
    },
    {
      age: 52,
      m: 49.5464,
      s: 0.02868,
      sd: 1.421,
      percentiles: {
        p1: 46.2,
        p3: 46.9,
        p5: 47.2,
        p15: 48.1,
        p25: 48.6,
        p50: 49.5,
        p75: 50.5,
        p85: 51.0,
        p95: 51.9,
        p97: 52.2,
        p99: 52.9,
      },
    },
    {
      age: 53,
      m: 49.5969,
      s: 0.02865,
      sd: 1.421,
      percentiles: {
        p1: 46.3,
        p3: 46.9,
        p5: 47.3,
        p15: 48.1,
        p25: 48.6,
        p50: 49.6,
        p75: 50.6,
        p85: 51.1,
        p95: 51.9,
        p97: 52.3,
        p99: 52.9,
      },
    },
    {
      age: 54,
      m: 49.6464,
      s: 0.02863,
      sd: 1.4214,
      percentiles: {
        p1: 46.3,
        p3: 47.0,
        p5: 47.3,
        p15: 48.2,
        p25: 48.7,
        p50: 49.6,
        p75: 50.6,
        p85: 51.1,
        p95: 52.0,
        p97: 52.3,
        p99: 53.0,
      },
    },
    {
      age: 55,
      m: 49.6947,
      s: 0.02861,
      sd: 1.4218,
      percentiles: {
        p1: 46.4,
        p3: 47.0,
        p5: 47.4,
        p15: 48.2,
        p25: 48.7,
        p50: 49.7,
        p75: 50.7,
        p85: 51.2,
        p95: 52.0,
        p97: 52.4,
        p99: 53.0,
      },
    },
    {
      age: 56,
      m: 49.7421,
      s: 0.02859,
      sd: 1.4221,
      percentiles: {
        p1: 46.4,
        p3: 47.1,
        p5: 47.4,
        p15: 48.3,
        p25: 48.8,
        p50: 49.7,
        p75: 50.7,
        p85: 51.2,
        p95: 52.1,
        p97: 52.4,
        p99: 53.1,
      },
    },
    {
      age: 57,
      m: 49.7885,
      s: 0.02856,
      sd: 1.422,
      percentiles: {
        p1: 46.5,
        p3: 47.1,
        p5: 47.2,
        p15: 48.3,
        p25: 48.8,
        p50: 49.8,
        p75: 50.7,
        p85: 51.3,
        p95: 52.1,
        p97: 52.5,
        p99: 53.1,
      },
    },
    {
      age: 58,
      m: 49.8341,
      s: 0.02854,
      sd: 1.4223,
      percentiles: {
        p1: 46.5,
        p3: 47.2,
        p5: 47.5,
        p15: 48.4,
        p25: 48.9,
        p50: 49.8,
        p75: 50.8,
        p85: 51.3,
        p95: 52.2,
        p97: 52.5,
        p99: 53.1,
      },
    },
    {
      age: 59,
      m: 49.8789,
      s: 0.02852,
      sd: 1.4226,
      percentiles: {
        p1: 46.6,
        p3: 47.2,
        p5: 47.5,
        p15: 48.4,
        p25: 48.9,
        p50: 49.9,
        p75: 50.8,
        p85: 51.4,
        p95: 52.2,
        p97: 52.6,
        p99: 53.2,
      },
    },
    {
      age: 60,
      m: 49.9229,
      s: 0.0285,
      sd: 1.4228,
      percentiles: {
        p1: 46.6,
        p3: 47.2,
        p5: 47.6,
        p15: 48.4,
        p25: 49.0,
        p50: 49.9,
        p75: 50.9,
        p85: 51.4,
        p95: 52.3,
        p97: 52.6,
        p99: 53.2,
      },
    },
  ],
};

export const whoGirlsHeadCircumferenceWeekly: GrowthDataSet = {
  id: 'who-girls-head-circumference-weekly-0-13',
  source: 'WHO',
  title: 'Head circumference-for-age',
  intervalType: 'week',
  gender: 'female',
  measurementType: 'head_circumference',
  ageRange: { min: 0, max: 13 },
  displayUnit: 'cm',
  dataPoints: [
    {
      age: 0,
      m: 33.8787,
      s: 0.03496,
      sd: 1.1844,
      percentiles: {
        p1: 31.1,
        p3: 31.7,
        p5: 31.9,
        p15: 32.7,
        p25: 33.1,
        p50: 33.9,
        p75: 34.7,
        p85: 35.1,
        p95: 35.8,
        p97: 36.1,
        p99: 36.6,
      },
    },
    {
      age: 1,
      m: 34.5529,
      s: 0.03374,
      sd: 1.1658,
      percentiles: {
        p1: 31.8,
        p3: 32.4,
        p5: 32.6,
        p15: 33.3,
        p25: 33.8,
        p50: 34.6,
        p75: 35.3,
        p85: 35.8,
        p95: 36.5,
        p97: 36.7,
        p99: 37.3,
      },
    },
    {
      age: 2,
      m: 35.2272,
      s: 0.03251,
      sd: 1.1452,
      percentiles: {
        p1: 32.6,
        p3: 33.1,
        p5: 33.3,
        p15: 34.0,
        p25: 34.5,
        p50: 35.2,
        p75: 36.0,
        p85: 36.4,
        p95: 37.1,
        p97: 37.4,
        p99: 37.9,
      },
    },
    {
      age: 3,
      m: 35.843,
      s: 0.03231,
      sd: 1.1581,
      percentiles: {
        p1: 33.1,
        p3: 33.7,
        p5: 33.9,
        p15: 34.6,
        p25: 35.1,
        p50: 35.8,
        p75: 36.6,
        p85: 37.0,
        p95: 37.7,
        p97: 38.0,
        p99: 38.5,
      },
    },
    {
      age: 4,
      m: 36.3761,
      s: 0.03215,
      sd: 1.1695,
      percentiles: {
        p1: 33.7,
        p3: 34.2,
        p5: 34.5,
        p15: 35.2,
        p25: 35.6,
        p50: 36.4,
        p75: 37.2,
        p85: 37.6,
        p95: 38.3,
        p97: 38.6,
        p99: 39.1,
      },
    },
    {
      age: 5,
      m: 36.8472,
      s: 0.03202,
      sd: 1.1799,
      percentiles: {
        p1: 34.1,
        p3: 34.6,
        p5: 34.9,
        p15: 35.6,
        p25: 36.1,
        p50: 36.8,
        p75: 37.6,
        p85: 38.1,
        p95: 38.8,
        p97: 39.1,
        p99: 39.6,
      },
    },
    {
      age: 6,
      m: 37.2711,
      s: 0.03191,
      sd: 1.1893,
      percentiles: {
        p1: 34.5,
        p3: 35.0,
        p5: 35.3,
        p15: 36.0,
        p25: 36.5,
        p50: 37.3,
        p75: 38.1,
        p85: 38.5,
        p95: 39.2,
        p97: 39.5,
        p99: 40.0,
      },
    },
    {
      age: 7,
      m: 37.6584,
      s: 0.03182,
      sd: 1.1983,
      percentiles: {
        p1: 34.9,
        p3: 35.4,
        p5: 35.7,
        p15: 36.4,
        p25: 36.9,
        p50: 37.7,
        p75: 38.5,
        p85: 38.9,
        p95: 39.6,
        p97: 39.9,
        p99: 40.4,
      },
    },
    {
      age: 8,
      m: 38.0167,
      s: 0.03173,
      sd: 1.2063,
      percentiles: {
        p1: 35.2,
        p3: 35.7,
        p5: 36.0,
        p15: 36.8,
        p25: 37.2,
        p50: 38.0,
        p75: 38.8,
        p85: 39.3,
        p95: 40.0,
        p97: 40.3,
        p99: 40.8,
      },
    },
    {
      age: 9,
      m: 38.3516,
      s: 0.03166,
      sd: 1.2142,
      percentiles: {
        p1: 35.5,
        p3: 36.1,
        p5: 36.4,
        p15: 37.1,
        p25: 37.5,
        p50: 38.4,
        p75: 39.2,
        p85: 39.6,
        p95: 40.3,
        p97: 40.6,
        p99: 41.2,
      },
    },
    {
      age: 10,
      m: 38.6673,
      s: 0.03158,
      sd: 1.2211,
      percentiles: {
        p1: 35.8,
        p3: 36.4,
        p5: 36.7,
        p15: 37.4,
        p25: 37.8,
        p50: 38.7,
        p75: 39.5,
        p85: 39.9,
        p95: 40.7,
        p97: 41.0,
        p99: 41.5,
      },
    },
    {
      age: 11,
      m: 38.9661,
      s: 0.03152,
      sd: 1.2282,
      percentiles: {
        p1: 36.1,
        p3: 36.7,
        p5: 36.9,
        p15: 37.7,
        p25: 38.1,
        p50: 39.0,
        p75: 39.8,
        p85: 40.2,
        p95: 41.0,
        p97: 41.3,
        p99: 41.8,
      },
    },
    {
      age: 12,
      m: 39.2501,
      s: 0.03146,
      sd: 1.2348,
      percentiles: {
        p1: 36.4,
        p3: 36.9,
        p5: 37.2,
        p15: 38.0,
        p25: 38.4,
        p50: 39.3,
        p75: 40.1,
        p85: 40.5,
        p95: 41.3,
        p97: 41.6,
        p99: 42.1,
      },
    },
    {
      age: 13,
      m: 39.521,
      s: 0.0314,
      sd: 1.241,
      percentiles: {
        p1: 36.6,
        p3: 37.2,
        p5: 37.5,
        p15: 38.2,
        p25: 38.7,
        p50: 39.5,
        p75: 40.4,
        p85: 40.8,
        p95: 41.6,
        p97: 41.9,
        p99: 42.4,
      },
    },
  ],
};
